// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ensox","textarea":"styles_textarea__29JTq"};